import { deleteCookie, getCookie, setCookie } from '@/shared/utils/cookies'
import { add } from 'date-fns'

type StorageType = 'local' | 'session'

export class CacheService {
  static PREFIX = 'visitors-cache_'
  private storage: Storage

  constructor(storageType: StorageType = 'local') {
    this.storage = storageType === 'session' ? sessionStorage : localStorage
  }

  set(name: string, value: object | string, expires: any = Infinity) {
    const expiresDate = expires === Infinity ? new Date(2100, 12, 12) : add(new Date(), expires)
    const key = CacheService.PREFIX + name
    setCookie(key, name, { expires: expiresDate })
    this.storage.setItem(key, JSON.stringify(value))
  }

  get(name: string) {
    const key = CacheService.PREFIX + name
    const isExpired = !getCookie(key)
    if (isExpired) {
      this.storage.removeItem(key)
      return null
    }
    return this.getFromStorage(name)
  }

  getFromStorage(name: string) {
    const key = CacheService.PREFIX + name
    const item = this.storage.getItem(key)
    return item ? JSON.parse(item) : null
  }

  delete(name: string) {
    const key = CacheService.PREFIX + name
    deleteCookie(key)
    this.storage.removeItem(key)
  }
}

export const useCacheService = (storageType: StorageType = 'local') => new CacheService(storageType)
